import request from '../../../api/request';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../types/paginationRequestType';
import {
  Institution,
  InstitutionFormData,
  InstitutionRequest,
  InstitutionFilters,
} from './interfaces/type';

const INSTITUTIONS_ENDPOINT = {
  FORM_DATA: `maintainers-portal/general-configuration/institutions/form`,
  PAGINATED: `maintainers-portal/general-configuration/institutions`,
  CREATE: `maintainers-portal/general-configuration/institutions`,
  UPDATE: (institutionId: string | number) =>
    `maintainers-portal/general-configuration/institutions/${institutionId}`,
  DELETE: (institutionId: string | number) =>
    `maintainers-portal/general-configuration/institutions/${institutionId}`,
};

export async function paginated(
  params: PaginationQueryDto<InstitutionFilters>,
) {
  return request<PaginationRequestType<Institution>>(
    INSTITUTIONS_ENDPOINT.PAGINATED,
    {
      params: {
        ...params,
        page: params.page - 1,
      },
    },
  );
}

export async function getFormData() {
  return request<InstitutionFormData>(INSTITUTIONS_ENDPOINT.FORM_DATA);
}

export async function createInstitution(data: InstitutionRequest) {
  return request(INSTITUTIONS_ENDPOINT.CREATE, {
    method: 'POST',
    data,
  });
}

export async function updateInstitution(
  institutionId: string | number,
  data: InstitutionRequest,
) {
  return request(INSTITUTIONS_ENDPOINT.UPDATE(institutionId), {
    method: 'PUT',
    data,
  });
}

export async function deleteInstitution(institutionId: string | number) {
  return request(INSTITUTIONS_ENDPOINT.DELETE(institutionId), {
    method: 'DELETE',
  });
}
